import { put, takeEvery, all, call } from 'redux-saga/effects'
import { API } from '@Root/API'
import * as types from './venueActivity.types'
import { actions } from './venueActivity.actions'
import { saveDataOptionsToLocalStorage } from '@Root/helpers'
import { snackbarActions } from '@Root/store'

function* get({ payload }) {
  yield put(actions.toggleLoading(true))
  const { data, history } = payload
  const { studyProgrammeId, studentCourseSessionId, contactId, venueActivityId } = data
  try {
    const response = yield call(API.studies.studentCourseSession.venueActivity.get, studentCourseSessionId, venueActivityId)
    yield put(actions.set(response.data.data))
    yield put(actions.setPermissions(response.data.permissions))
  } catch (error) {
    history.push(`/home/studies/programmes/study/${contactId}/${studyProgrammeId}/off_venue_activity`)
    console.log(error)
  }
  yield put(actions.toggleLoading(false))
}

function* create({ payload }) {
  yield put(actions.toggleLoading(true))
  yield put(actions.setErrors({}))
  const { data, history, studyProgrammeId, contactId, studentCourseSessionId } = payload
  try {
    const response = yield call(API.studies.studentCourseSession.venueActivity.create, studentCourseSessionId, data)
    history.push(`/home/studies/programmes/study/${contactId}/${studyProgrammeId}/off_venue_activity/${response.data.data.id}`)
    yield put(snackbarActions.setSuccessNotification({ text: 'The Off Venue Activity has been created successfully!' }))
  } catch (error) {
    const { messages } = error.response.data
    yield put(actions.set(data))
    yield put(actions.setErrors(messages))
  }
  yield put(actions.toggleLoading(false))
}

function* edit({ payload }) {
  yield put(actions.toggleLoading(true))
  yield put(actions.setErrors({}))
  const { venueActivityId, studentCourseSessionId, data } = payload
  try {
    const response = yield call(API.studies.studentCourseSession.venueActivity.edit, studentCourseSessionId, venueActivityId, data)
    yield put(actions.set(response.data.data))
    yield put(actions.toggleSuccess(true))
    yield put(snackbarActions.setSuccessNotification({ text: 'The Off Venue Activity has been saved successfully!' }))
  } catch (error) {
    const { messages } = error.response.data
    yield put(actions.set(data))
    yield put(actions.setErrors(messages))
  }
  yield put(actions.toggleSuccess(false))
  yield put(actions.toggleLoading(false))
}

function* remove({ payload }) {
  yield put(actions.toggleLoading(true))
  const { data, history } = payload
  const { contactId, studyProgrammeId, studentCourseSessionId, venueActivityId } = data
  try {
    yield call(API.studies.studentCourseSession.venueActivity.remove, studentCourseSessionId, venueActivityId)
    history.push(`/home/studies/programmes/study/${contactId}/${studyProgrammeId}/off_venue_activity`)
    yield put(snackbarActions.setSuccessNotification({ text: 'The Off Venue Activity has been deleted successfully!' }))
  } catch (error) {
    console.log(error)
  }
  yield put(actions.toggleLoading(false))
}

function* getOptions() {
  try {
    const { data } = yield call(API.studies.studentCourseSession.venueActivity.options.getStatic)
    const generateObject = arr => arr.map(obj => ({ value: obj.id, label: `${obj.code} - ${obj.label}` }))
    const formattedData = {
      activity_duration_types: generateObject(data.activity_duration_types),
      mobility_schemes: generateObject(data.mobility_schemes),
      activity_type_identifiers: generateObject(data.activity_type_identifiers),
      countries: generateObject(data.countries),
      host_identifiers: generateObject(data.host_identifiers),
      host_identifier_types: generateObject(data.host_identifier_types),
    }
    yield put(actions.setOptions(formattedData))
    saveDataOptionsToLocalStorage('offVenueActivity', formattedData)
  } catch (error) {
    console.log(error)
  }
}

export function* rootSaga() {
  yield all([
    takeEvery(types.GET_VENUE_ACTIVITY, get),
    takeEvery(types.CREATE_VENUE_ACTIVITY, create),
    takeEvery(types.EDIT_VENUE_ACTIVITY, edit),
    takeEvery(types.DELETE_VENUE_ACTIVITY, remove),
    takeEvery(types.GET_OPTIONS, getOptions),
  ])
}
